import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { STAGING_ID } from '../../../../constants/constants';

interface IInitialState {
    stagingId: string | null;
}

const storedStagingId = localStorage.getItem(STAGING_ID) as string;
const initialStagingId: string | null = storedStagingId || null;

const initialState: IInitialState = {
    stagingId: initialStagingId,
};

const stagingIdSlice = createSlice({
    name: 'projectId',
    initialState,
    reducers: {
        saveStagingId: (state: IInitialState, action: PayloadAction<string>) => {
            state.stagingId = action.payload;
            localStorage.setItem(STAGING_ID, action.payload.toString());
        },

        removeStagingId: (state: IInitialState) => {
            state.stagingId = null;
            localStorage.removeItem(STAGING_ID);
        },
    },
});

export default stagingIdSlice.reducer;
export const { saveStagingId, removeStagingId } = stagingIdSlice.actions;
